// extracted by mini-css-extract-plugin
module.exports = {"content":"title-and-text_content__1rPdy","title":"title-and-text_title___ADvM","text":"title-and-text_text__8CTmh"};